import MapZoom from './MapZoom';

function Map(props) {
  return (
    <>
      <div id={props.id} className="mapArea" />
      <MapZoom handler={props.zoomHandler} />
    </>
  );
}

export default Map;
